'use client';

import { useState, useEffect, useRef } from "react";
import { FaPhoneAlt } from 'react-icons/fa';

// Components
import Modal from '@src/components/atoms/modal';
import BeatLoader from '@src/components/atoms/beat-loader';

// Assets
import IArrowRight from "@public/svg/i-arrow-right";
import { FiPhone, FiMapPin } from 'react-icons/fi';
import { GoDotFill, GoArrowRight } from 'react-icons/go';
import { FaMapMarkerAlt } from 'react-icons/fa';

const searchTypeText = {
  jual: {
    placeholder:
      'Cari berdasarkan area atau kota. Pilih dari daftar yang muncul.',
    loading: 'Sedang mencari lokasi...',
    notFound:
      'Lokasi tidak ditemukan. Coba ketik area/kota lain atau gunakan kata kunci.',
  },
  sewa: {
    placeholder:
      'Cari berdasarkan area atau kota. Pilih dari daftar yang muncul.',
    loading: 'Sedang mencari lokasi...',
    notFound:
      'Lokasi tidak ditemukan. Coba ketik area/kota lain atau gunakan kata kunci.',
  },
  agent: {
    placeholder:
      'Cari berdasarkan nama, nomor telepon, no. registrasi. Pilih dari daftar yang muncul.',
    loading: 'Sedang mencari marketing...',
    notFound:
      'Marketing tidak ditemukan. Cek kembali kata kunci yang dimasukkan.',
  },
  kantor: {
    placeholder: 'Nama kantor, kota, area',
    loading: 'Sedang mencari kantor...',
    notFound: 'Kantor tidak ditemukan. Cek kembali kata kunci yang dimasukkan.',
  },
};

const ModalSearchMobile = ({
    onClose,
    displaySearch,
    handleChangeSearch,
    listLocation,
    lastItemRef,
    isFetching,
    handleSelectLocation,
    highlightText,
    searchType = 'jual',
    placeholder = `cari "Setiabudi" atau "Jakarta Selatan"`,
    ...props
}) => {
    const [onFocus, setOnFocus] = useState(false);
    const inputRef = useRef(null);

    useEffect(() => {
        // Focus the input when modal opens with a small delay to ensure proper rendering
        const timer = setTimeout(() => {
            if (inputRef.current) {
                inputRef.current.focus();
            }
        }, 100);

        return () => clearTimeout(timer);
    }, []);

    return (
        <Modal {...props} onClose={onClose} className="!items-start hidden dd2-xl:flex">
            <div className='z-[42] w-screen h-screen bg-white overflow-y-auto'>
                <div className='flex gap-[12px] items-center px-6 py-4 border-t border-solid border-[#DEDFDE]'>
                    <button
                        className='flex justify-center items-center'
                        onClick={onClose}
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path fillRule="evenodd" clipRule="evenodd" d="M2.46967 11.4697C2.17678 11.7626 2.17678 12.2374 2.46967 12.5303L10.4697 20.5303C10.7626 20.8232 11.2374 20.8232 11.5303 20.5303C11.8232 20.2374 11.8232 19.7626 11.5303 19.4697L4.06066 12L11.5303 4.53033C11.8232 4.23744 11.8232 3.76256 11.5303 3.46967C11.2374 3.17678 10.7626 3.17678 10.4697 3.46967L2.46967 11.4697Z" fill="#040704" />
                            <path fillRule="evenodd" clipRule="evenodd" d="M21.75 12C21.75 12.4142 21.4142 12.75 21 12.75H4V11.25H21C21.4142 11.25 21.75 11.5858 21.75 12Z" fill="#040704" />
                        </svg>
                    </button>

                    <input
                        ref={inputRef}
                        className='rounded-[8px] border border-solid border-[#040704] bg-white w-full px-4 py-2 text-[17px]/[23.8px] tracking-[-0.17px] font-satoshi placeholder:text-[#686A68]'
                        placeholder={placeholder}
                        value={displaySearch}
                        onChange={handleChangeSearch}
                        onFocus={() => setOnFocus(true)}
                    />
                </div>
                {(onFocus || !!displaySearch) && <p className="border-t border-solid border-[#DEDFDE] font-satoshi text-[11px]/[15.6px] tracking-[-0.11px] text-[#686A68] px-6 py-4">
                    {searchTypeText[searchType].placeholder}
                </p>}
                {!!displaySearch && (
                    <div>
                        {/* Results list */}
                        {listLocation && listLocation.map((item, idx) => (
                            <button
                                ref={idx === listLocation.length - 1 ? lastItemRef : null}
                                key={`${item.id}-${idx}`}
                                className={`w-full font-satoshi flex items-center justify-between py-4 px-6 text-[17px] border-b-[0.5px] border-dashed border-[#E6E7E8] ${
                                  searchType === 'agent' || searchType === 'kantor'
                                    ? 'items-start'
                                    : ''
                                }`}
                                onClick={() => handleSelectLocation(item)}
                            >
                                {searchType === 'agent' ? (
                                    <div className="flex flex-col items-start gap-1 flex-1">
                                        <h3 className="font-satoshi-bold text-[17px]/[23.8px] mb-1 tracking-[0.17px] text-[#040704]">
                                            {highlightText(item.full_name, displaySearch)}
                                        </h3>
                                        <div className="flex items-center gap-2">
                                            <div className="flex items-center gap-1">
                                                <FaPhoneAlt className="text-[14px] text-[#252526]" />
                                                <span className="text-[14px]/[19.6px] text-[#686A68]">
                                                    {item.phone || '-'}
                                                </span>
                                            </div>
                                            <GoDotFill className="text-base text-[#DEDFDE]" />
                                            <span className="text-[14px]/[19.6px] text-[#686A68]">
                                                {item.office || '-'}
                                            </span>
                                        </div>
                                    </div>
                                ) : searchType === 'kantor' ? (
                                    <div className="flex flex-col items-start gap-1 flex-1">
                                        <h3 className="font-satoshi-bold text-[17px]/[23.8px] mb-1 tracking-[0.17px] text-[#040704]">
                                            {highlightText(item.name, displaySearch)}
                                        </h3>
                                        <div className="flex items-start gap-1">
                                            <FaMapMarkerAlt size={16} className="text-[#252526] mt-0.5" />
                                            <div>
                                                <p className="text-[14px]/[19.6px] text-[#686A68] text-start">
                                                    {item.city || '-'}, {item.area || '-'}
                                                </p>
                                                {item.address && (
                                                    <p className="text-[11px]/[15.4px] text-[#686A68] text-start">
                                                        {item.address}
                                                    </p>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                ) : (
                                    highlightText(item.name, displaySearch)
                                )}

                                <div className="flex items-center gap-2">
                                    <p className="bg-[#EBF0F7] rounded-[4px] px-2 font-satoshi text-[11px]/[15.6px] tracking-[0.11px] text-[#3268AE]">
                                        {searchType === 'agent' ? `#${item.id}` : item.slug}
                                    </p>
                                    <div className="flex items-center justify-center bg-[#F5F5F5] rounded-[4px] p-1">
                                        <GoArrowRight className="text-base text-[#686A68]" />
                                    </div>
                                </div>
                            </button>
                        ))}

                        {!!displaySearch && !listLocation?.length && (
                            <div 
                                onClick={() => handleSelectLocation({ 
                                    name: displaySearch, 
                                    slug: 'kata-kunci' 
                                })} 
                                className="px-6 py-4 flex items-center justify-between gap-2 border-b-[0.5px] border-dashed border-[#DEDFDE] py-4"
                            >
                                <p className="font-satoshi text-[17px]/[23.8px] tracking-[0.17px] text-[#040704]">{displaySearch}</p>

                                <div className="flex items-center gap-2">
                                    <p className="bg-[#EBF0F7] rounded-[4px] px-2 font-satoshi text-[11px]/[15.6px] tracking-[0.11px] text-[#3268AE]">Kata Kunci</p>
                                    <div className="w-4 h-4 bg-[#F5F5F5] rounded-[4px] p-1 flex items-center justify-center">
                                        <IArrowRight width="8px" height="8px" color="#686A68" />
                                    </div>
                                </div>
                            </div>
                        )}


                        {/* Loading state */}
                        {isFetching && !!displaySearch && (
                            <div className="px-6 py-4 flex items-center gap-2 justify-between">
                                <p className="font-satoshi text-[14px]/[19.6px] text-[#040704]">{searchTypeText[searchType].loading}</p>
                                <BeatLoader />
                            </div>
                        )}

                        {/* No results state */}
                        {!isFetching && !!displaySearch && listLocation?.length === 0 && (
                            <div className="px-6 py-4 flex items-start gap-4 justify-between py-4 w-full">
                                <p className="font-satoshi text-[14px]/[19.6px] text-[#040704]">
                                    {searchTypeText[searchType].notFound}
                                </p>
                            </div>
                        )}
                    </div>
                )}
            </div>
        </Modal>
    );
};

export default ModalSearchMobile;